import { gql } from '@apollo/client'

export const GOALS = gql`
  query Goals(
    $activeOnly: Boolean
    $includeOnboarding: Boolean
    $goalId: String
    $nonprofitOrgId: Int!
    $type: GoalType
  ) {
    goals(
      activeOnly: $activeOnly
      includeOnboarding: $includeOnboarding
      goalId: $goalId
      nonprofitOrgId: $nonprofitOrgId
      type: $type
    ) {
      archivedAt
      category
      impactCategory
      isComplete
      numProgressUpdates
      numAttachments
      hasChart
      hasUpdates
      chartId
      ChecklistItem {
        createdAt
        goalId
        dueDate
        id
        isCompleted
        linkText
        linkUrl
        owner {
          id
          firstName
          lastName
        }
        resourceId
        title
        updatedAt
        checklistItemGroupId
      }
      createdAt
      description
      endDate
      id
      GoalUpdate {
        createdAt
        description
        id
        goalId
        lastUpdatedUser {
          id
          firstName
          lastName
        }
      }
      nonprofitOrgId
      metric
      owner {
        id
        firstName
        lastName
      }
      FunderOrgToSharedGoal {
        funderOrgId
        sharedAt
        goalId
        funderOrg {
          id
          name
        }
        isGoalSharedByFunder
        isGoalSharedByNonprofit
        archivedAt
      }
      startDate
      target
      templateLibraryId
      title
      type
      unitOfMeasurement
      updatedAt
      attachments {
        id
        createdAt
        filename
        format
        secureUrl
        publicId
        resourceType
        owner {
          id
          firstName
          lastName
        }
      }
    }
  }
`
